import React, { useContext, useRef } from "react";
import { useLocation, useParams } from "react-router-dom";
import { Rating } from "primereact/rating";
import Footer from "../Footer/Footer";

// components
import BlogSidebar from "./BlogSidebar";
import Header from "../Header/Header";

// context
import { UserData } from "../../contexts/UserInfoContext";

// img
import postImg from "../../images/post-img.png";
import { useEffect } from "react";
import { useState } from "react";
import { getData, postData } from "../../services/API";
import CommentSection from "./CommentSection";
import { toFarsiNumber } from "../../helper/helper";
import Loading from "../shared/Loading";
import ScrollTop from "../shared/ScrollTop";
import MobileHeader from "../Header/Mobile/MobileHeader";
import MobileNavbar from "../Header/Mobile/MobileNavbar";
import PostComment from "./PostComment";
import SendComment from "./SendComment";
import { getItemStorage } from "../../Localstorage/useLocalStorage";
import { Toast } from "primereact/toast";
import Skeleton from "react-loading-skeleton";
import CircleLoading from "../shared/CircleLoading";

const BlogPost = () => {
  const { user } = useContext(UserData);
  const [postRes, setPostRes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [date, setDate] = useState(null);
  const [data, setData] = useState([]);
  const [comments, setComments] = useState([]);
  const [imageLoading, setImageLoading] = useState(false);
  const [tags, setTags] = useState([]);
  const [categories, setCategories] = useState([]);
  const [rate, setRate] = useState(null);
  const [rateSended, setRateSended] = useState(false);
  const [commentLoading, setCommentLoading] = useState(true);
  const [page, setPage] = useState({});
  const [sendRate, setSendRate] = useState(false);
  const [rateLoading, setRateLoading] = useState(false);
  const [isRateSubmitted, setIsRateSubmitted] = useState(null);

  const params = useParams();
  const postSlug = params.postSlug;

  const token = getItemStorage("token");
  const loc = useLocation();

  const toastErr = useRef(null);
  const toastSucc = useRef(null);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });

    setLoading(true);

    getData(`/blog/post/show/${postSlug}`, {}, false)
      .then((res) => {
        setPostRes(res.data.details);
        setTags(res.data.tags);
        setCategories(res.data.categories.children);
        setData(res.data);
        setDate(res.data.details.updated_at);
        setLoading(false);

        if (res.data.details.user_rate) {
          setIsRateSubmitted(res.data.details.user_rate);
          setRate(res.data.details.user_rate);
        }

        // get comments
        postData("/blog/post/comment/get-post-comments", {
          post_id: res.data.details.id,
          page: 1,
        })
          .then((res) => {
            setCommentLoading(false);

            setComments(res.data.comments);
            setPage({
              page: res.data.page,
              pages: res.data.pages,
            });

            // commentQuantity(res.data.comments);
          })
          .catch((err) => {
            setCommentLoading(false);
          });
      })
      .catch((err) => {
        setLoading(false);
      });
  }, [loc]);

  const rateOnChangeHandler = (e) => {
    setRate(e.value);
    setSendRate(true);
  };

  const rateSendHandler = () => {
    setRateLoading(true);

    if (!rateSended) {
      postData("/blog/post/rate", { number: rate, post_id: postRes.id })
        .then((res) => {
          setSendRate(false);
          setRateSended(true);
          toastSucc.current.show({
            severity: "success",
            summary: "با موفقیت انجام شد",
            detail: "امتیاز شما با موفقیت ثبت شد",
            life: 3500,
          });
        })
        .catch((err) => {
          toastErr.current.show({
            severity: "error",
            summary: "خطا هنگام ثبت امتیاز",
            detail: err.response.data.message,
            life: 3500,
          });
        });
    }
  };

  return (
    <div className="blog flex flex-col items-center justify-center w-full pb-10">
      <Header userData={user} />
      <MobileHeader />
      <MobileNavbar />
      <ScrollTop />

      <Toast ref={toastSucc} />
      <Toast ref={toastErr} />

      <div className="w-full max-w-[1300px] flex-col lg:flex-row blog-content h-auto flex gap-10 mt-4 px-3 2xl:px-0">
        <div className="w-full flex flex-col gap-10">
          <div className="blog-post p-6 w-full h-fit flex flex-col gap-5 pb-5 bg-[#222] rounded-3xl overflow-hidden shadow-[0px_5px_25px_rgba(79,105,139,.09)]">
            <div className="">
              <div>
                {loading ? (
                  <Skeleton className="w-full block h-10 rounded-xl" />
                ) : (
                  <div className="flex flex-col">
                    <div className="flex md:items-center flex-col md:flex-row gap-4 justify-between border-b border-gray-800 pb-4">
                      <div className="flex items-center gap-2">
                        <span className="block w-5 h-[6px] bg-yellow-700 rounded-full"></span>
                        {/* post title */}
                        <h1 className="text-2xl font-black text-gray-200">
                          {postRes?.title}
                        </h1>
                      </div>
                    </div>

                    <div className="pt-4 grid grid-cols-2 md:grid-cols-4 gap-4">
                      <div className="flex items-center gap-2">
                        <div className="flex justify-center items-center w-8 h-8 rounded-lg bg-gradient-to-tl from-yellow-900 to-yellow-500">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            fill="currentColor"
                            className="w-5 h-5 fill-white"
                          >
                            <path
                              fillRule="evenodd"
                              d="M4.848 2.771A49.144 49.144 0 0 1 12 2.25c2.43 0 4.817.178 7.152.52 1.978.292 3.348 2.024 3.348 3.97v6.02c0 1.946-1.37 3.678-3.348 3.97a48.901 48.901 0 0 1-3.476.383.39.39 0 0 0-.297.17l-2.755 4.133a.75.75 0 0 1-1.248 0l-2.755-4.133a.39.39 0 0 0-.297-.17 48.9 48.9 0 0 1-3.476-.384c-1.978-.29-3.348-2.024-3.348-3.97V6.741c0-1.946 1.37-3.68 3.348-3.97ZM6.75 8.25a.75.75 0 0 1 .75-.75h9a.75.75 0 0 1 0 1.5h-9a.75.75 0 0 1-.75-.75Zm.75 2.25a.75.75 0 0 0 0 1.5H12a.75.75 0 0 0 0-1.5H7.5Z"
                              clipRule="evenodd"
                            />
                          </svg>
                        </div>

                        <span className="text-gray-300">{`${toFarsiNumber(
                          comments.length
                        )} دیدگاه`}</span>
                      </div>

                      <div className="flex items-center gap-2">
                        <div className="flex justify-center items-center w-8 h-8 rounded-lg bg-gradient-to-tl from-yellow-900 to-yellow-500">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            fill="currentColor"
                            className="w-5 h-5 fill-white"
                          >
                            <path d="M12.75 12.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM7.5 15.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM8.25 17.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM9.75 15.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM10.5 17.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM12 15.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM12.75 17.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM14.25 15.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM15 17.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM16.5 15.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM15 12.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM16.5 13.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z" />
                            <path
                              fillRule="evenodd"
                              d="M6.75 2.25A.75.75 0 0 1 7.5 3v1.5h9V3A.75.75 0 0 1 18 3v1.5h.75a3 3 0 0 1 3 3v11.25a3 3 0 0 1-3 3H5.25a3 3 0 0 1-3-3V7.5a3 3 0 0 1 3-3H6V3a.75.75 0 0 1 .75-.75Zm13.5 9a1.5 1.5 0 0 0-1.5-1.5H5.25a1.5 1.5 0 0 0-1.5 1.5v7.5a1.5 1.5 0 0 0 1.5 1.5h13.5a1.5 1.5 0 0 0 1.5-1.5v-7.5Z"
                              clipRule="evenodd"
                            />
                          </svg>
                        </div>

                        <span className="text-gray-300">
                          {new Intl.DateTimeFormat("fa-IR", {
                            year: "numeric",
                            month: "short",
                            day: "numeric",
                          }).format(new Date(date && date))}
                        </span>
                      </div>

                      <div className="flex items-center gap-2">
                        <div className="flex justify-center items-center w-8 h-8 rounded-lg bg-gradient-to-tl from-yellow-900 to-yellow-500">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            fill="currentColor"
                            className="w-5 h-5 fill-white"
                          >
                            <path
                              fillRule="evenodd"
                              d="M7.5 6a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0ZM3.751 20.105a8.25 8.25 0 0 1 16.498 0 .75.75 0 0 1-.437.695A18.683 18.683 0 0 1 12 22.5c-2.786 0-5.433-.608-7.812-1.7a.75.75 0 0 1-.437-.695Z"
                              clipRule="evenodd"
                            />
                          </svg>
                        </div>

                        <span className="text-gray-300">
                          {postRes.author.name +
                            " " +
                            postRes.author.family_name}
                        </span>
                      </div>

                      <div className="w-fit h-10 text-white flex items-center gap-1 px-4 text-sm md:text-base justify-center bg-gradient-to-tl from-yellow-900 to-yellow-500 rounded-2xl">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          strokeWidth="1.5"
                          stroke="currentColor"
                          className="w-5 h-5 stroke-white"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                          />
                        </svg>

                        <span>۸۷ دقیقه برای مطالعه</span>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* post img */}
            <div className="w-full flex justify-center lg:min-h-[250px]">
              {!imageLoading ||
                (loading && (
                  <div className="w-full">
                    <Skeleton className="w-full block h-[450px] rounded-xl" />
                  </div>
                ))}
              <img
                src={`https://api.myunibest.ir/${postRes.image}`}
                className={`w-full rounded-2xl ${!imageLoading && "hidden"} max-h-96 object-cover`}
                alt=""
                onLoad={() => setImageLoading(true)}
              />
            </div>

            {/* post paragraph */}
            {loading ? (
              <div className="w-full flex flex-col gap-3">
                <Skeleton className="h-6 rounded-xl" />
                <Skeleton className="h-6 rounded-xl" />
                <Skeleton className="h-6 rounded-xl" />
                <Skeleton className="h-6 rounded-xl" />
              </div>
            ) : (
              <div className="flex flex-col gap-7">
                <div
                  dangerouslySetInnerHTML={{ __html: postRes.content }}
                  className="self-start course-content w-full leading-7 text-gray-200 flex flex-col gap-3"
                ></div>

                {/* tags & categories */}
                <div className="flex flex-col gap-5">
                  <div className="flex flex-col gap-3">
                    <div className="flex items-center gap-2">
                      <div className="flex justify-center items-center w-8 h-8 rounded-lg bg-gradient-to-tl from-yellow-900 to-yellow-500">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          fill="currentColor"
                          class="w-5 h-5 fill-white"
                        >
                          <path
                            fillRule="evenodd"
                            d="M1.5 7.125c0-1.036.84-1.875 1.875-1.875h6c1.036 0 1.875.84 1.875 1.875v3.75c0 1.036-.84 1.875-1.875 1.875h-6A1.875 1.875 0 0 1 1.5 10.875v-3.75Zm12 1.5c0-1.036.84-1.875 1.875-1.875h5.25c1.035 0 1.875.84 1.875 1.875v8.25c0 1.035-.84 1.875-1.875 1.875h-5.25a1.875 1.875 0 0 1-1.875-1.875v-8.25ZM3 16.125c0-1.036.84-1.875 1.875-1.875h5.25c1.036 0 1.875.84 1.875 1.875v2.25c0 1.035-.84 1.875-1.875 1.875h-5.25A1.875 1.875 0 0 1 3 18.375v-2.25Z"
                            clipRule="evenodd"
                          />
                        </svg>
                      </div>

                      <h3 className="text-gray-200">دسته بندی ها :</h3>
                    </div>
                    <div className="flex items-center flex-wrap gap-2">
                      {categories.map((tag) => (
                        <div className="py-2 px-3 rounded-lg bg-yellow-800 bg-opacity-20 text-yellow-700 hover:text-white hover:bg-yellow-700 transition-all duration-300">
                          {tag.name}
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="flex flex-col gap-3">
                    <div className="flex items-center gap-2">
                      <div className="flex justify-center items-center w-8 h-8 rounded-lg bg-gradient-to-tl from-yellow-900 to-yellow-500">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          fill="currentColor"
                          className="w-5 h-5 fill-white"
                        >
                          <path
                            fillRule="evenodd"
                            d="M5.25 2.25a3 3 0 0 0-3 3v4.318a3 3 0 0 0 .879 2.121l9.58 9.581c.92.92 2.39 1.186 3.548.428a18.849 18.849 0 0 0 5.441-5.44c.758-1.16.492-2.629-.428-3.548l-9.58-9.581a3 3 0 0 0-2.122-.879H5.25ZM6.375 7.5a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25Z"
                            clipRule="evenodd"
                          />
                        </svg>
                      </div>

                      <h3 className="text-gray-200">برچسب ها :</h3>
                    </div>
                    <div className="flex items-center flex-wrap gap-2">
                      {tags.map((tag) => (
                        <div className="py-2 px-3 rounded-lg bg-yellow-800 bg-opacity-20 text-yellow-700 hover:text-white hover:bg-yellow-700 transition-all duration-300">
                          {tag.name}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
          {/* comment section */}
          <div className="w-full h-auto flex flex-col gap-10 p-5 pt-6 relative bg-[#222] overflow-hidden rounded-xl shadow-[0px_5px_25px_rgba(79,105,139,.09)]">
            <div className="flex flex-col gap-6">
              {/* comment title */}
              <div className="flex justify-between items-center">
                <div className="flex items-center gap-2">
                  <span className="block w-5 h-2 bg-yellow-700 shadow-md rounded-full"></span>
                  <h3 className="text-2xl font-black text-gray-200">
                    دیدگاه شما
                  </h3>
                </div>
              </div>

              {token ? (
                <div className="flex flex-col gap-5">
                  <div className="w-full md:max-h-14 flex flex-col-reverse md:flex-row gap-4 justify-between items-center p-4 bg-gray-800 rounded-xl">
                    {isRateSubmitted ? (
                      <span className="text-green-600">
                        شما قبلا امتیاز داده اید
                      </span>
                    ) : sendRate ? (
                      <div className="flex flex-col md:flex-row text-gray-200 items-center gap-4">
                        <span>مطمنید میخواهید امتیاز شما ثبت شود ؟</span>

                        <div className="flex items-center gap-4">
                          <button
                            onClick={rateSendHandler}
                            className="bg-gradient-to-tl from-green-600 to-green-300 text-sm p-2 text-white rounded-xl"
                          >
                            {rateLoading ? <CircleLoading /> : "بله ثبت امتیاز"}
                          </button>
                          <button
                            onClick={() => {
                              setSendRate(false);
                              setRate(null);
                            }}
                            className="text-red-600"
                          >
                            خیر
                          </button>
                        </div>
                      </div>
                    ) : rateSended ? (
                      <span className="text-green-500">امتیاز شما ثبت شد</span>
                    ) : (
                      <span className="text-gray-200">امتیاز شما</span>
                    )}
                    <Rating
                      value={rate}
                      readOnly={rateSended || isRateSubmitted ? true : false}
                      cancel={false}
                      onChange={rateOnChangeHandler}
                    />
                  </div>

                  <SendComment data={postRes.id} />
                </div>
              ) : (
                <span className="text-gray-200">
                  برای ثبت امتیاز و دیدگاه وارد حساب کاربری شوید !
                </span>
              )}
            </div>

            <div className="flex flex-col gap-6">
              {/* comment title */}
              <div className="flex justify-between items-center">
                <div className="flex items-center gap-2">
                  <span className="block w-5 h-2 bg-yellow-700 shadow-md rounded-full"></span>
                  <h3 className="text-2xl font-black text-gray-200">
                    دیدگاه کاربران
                  </h3>
                </div>

                <span className="text-lg text-gray-200">
                  {!commentLoading
                    ? toFarsiNumber(comments.length)
                    : toFarsiNumber(0)}{" "}
                  دیدگاه
                </span>
              </div>

              {/* comments */}
              {commentLoading && loading ? (
                <Loading />
              ) : (
                <div className="flex flex-col gap-4">
                  {comments.length > 0 ? (
                    comments.map((comment) => (
                      <PostComment post_id={postRes.id} data={comment} />
                    ))
                  ) : (
                    <span className="text-gray-200">
                      دیدگاهی برای این دوره وجود ندارد !
                    </span>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>

        <BlogSidebar />
      </div>

      <Footer />
    </div>
  );
};

export default BlogPost;
